import { isNil } from 'lodash-es'
import { useTranslations } from 'next-intl'

import { TRoomDetail, TContractRoomDetail } from '@/entities/room'

import { Heading, Item, Label, List, Value } from '../../common'

export type Props = Pick<
  TRoomDetail,
  | 'includeElectricity'
  | 'includeWater'
  | 'includeGas'
  | 'managementFeeDescription'
> &
  Partial<Pick<TContractRoomDetail, 'includeInternet'>>

export const ManagementFee = ({
  includeElectricity,
  includeWater,
  includeGas,
  includeInternet,
  managementFeeDescription,
}: Props) => {
  const t = useTranslations('room_detail')

  const showInternet = !isNil(includeInternet)

  return (
    <section className="flex justify-between">
      <div className="w-[260px] space-y-5">
        <Heading>{t('included_utility_fee.title')}</Heading>
        <List spacing="medium" className="typo-body2 text-gray-900">
          <Item className="justify-between">
            <Label icon="gas" className="font-semibold">
              {t('included_utility_fee.gas')}
            </Label>
            <Value>
              {includeGas
                ? t('included_utility_fee.type.included')
                : t('included_utility_fee.type.not_included')}
            </Value>
          </Item>
          <Item className="justify-between">
            <Label icon="water" className="font-semibold">
              {t('included_utility_fee.water')}
            </Label>
            <Value>
              {includeWater
                ? t('included_utility_fee.type.included')
                : t('included_utility_fee.type.not_included')}
            </Value>
          </Item>
          <Item className="justify-between">
            <Label icon="electricity" className="font-semibold">
              {t('included_utility_fee.electric')}
            </Label>
            <Value>
              {includeElectricity
                ? t('included_utility_fee.type.included')
                : t('included_utility_fee.type.not_included')}
            </Value>
          </Item>
          {showInternet && (
            <Item className="justify-between">
              <Label icon="wifi" className="font-semibold">
                인터넷
              </Label>
              <Value>
                {includeInternet
                  ? t('included_utility_fee.type.included')
                  : t('included_utility_fee.type.not_included')}
              </Value>
            </Item>
          )}
        </List>
      </div>

      <div className="w-[330px] space-y-3">
        <Heading>{t('utility_fee_guide.title')}</Heading>
        <p className="typo-body2 font-normal whitespace-break-spaces text-gray-900">
          {managementFeeDescription}
        </p>
      </div>
    </section>
  )
}
